import { forwardRef, useMemo } from "react";

import { Icons } from "widgets";

import { type Organism } from "../../../../graphql.js";
import { ENTITY_TYPE, FEATURE_DISPLAY_NAME } from "../../../../settings/settings.js";
import { Tile, type TileProps } from "@/modules/core/components/Tile.tsx";
import { TileStatus } from "@/modules/core/components/settings.ts";

interface GenomeTileProps extends Pick<TileProps, "footNote" | "type" | "style"> {
  genome: Organism;
  hideIcon?: boolean;
  noLink?: boolean;
}

const GenomeTile = forwardRef<HTMLDivElement, GenomeTileProps>(function GenomeTile(props, ref) {
  const type = useMemo(() => {
    let type = "";

    /*
    props.genome.type stems from type() in OrganismData.java. It can be either
    null, "none", "reference" or "mutant"
     */
    if (props.genome.type) {
      type = `${props.genome.type} Genome`;
    }

    return props.type !== undefined ? props.type : type;
  }, [props.genome, props.type]);

  if (!props.genome) return null;

  return (
    <Tile
      title={props.genome.name}
      type={type}
      statusDisplayName={FEATURE_DISPLAY_NAME[ENTITY_TYPE.ORGANISM]}
      to={!props.noLink ? `/${ENTITY_TYPE.ORGANISM}/${props.genome.id}` : undefined}
      icon={props.hideIcon !== true ? <img src={Icons.Tiles.Entity} width={24} height={30} /> : undefined}
      footNote={props.footNote}
      protectionStatus={props.genome.hidden ? TileStatus.RestrictedVisibility : TileStatus.Normal}
      ref={ref}
      style={props.style}
    >
      {props.genome.description}
    </Tile>
  );
});

export { GenomeTile };
